var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.client)?_c('client-form',{attrs:{"initial-client":_vm.client}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }